import { Component } from '@angular/core';
import { FieldArrayType, FormlyFormBuilder } from '@ngx-formly/core';

@Component({
  selector: 'formly-repeat-section',
  template: `
      <div *ngFor="let field of field.fieldGroup; let i = index;">
          <formly-group
                  [field]="field"
                  [options]="options"
                  [form]="formControl">
              <div class="col-sm-2 d-flex align-items-center" *ngIf="field?.fieldArray?.templateOptions?.showRemove">
                  <button class="btn btn-danger" type="button" (click)="remove(i)">Remove</button>
              </div>
          </formly-group>
      </div>
      <div style="margin-bottom:30px;" *ngIf="field?.fieldArray?.templateOptions?.btnText">
          <button class="btn btn-primary" type="button" (click)="add()">{{field.fieldArray.templateOptions.btnText}}</button>
      </div>
  `,
})
export class RepeatTypeComponent extends FieldArrayType {
  constructor(builder: FormlyFormBuilder) {
    super(builder);
  }
}
